import { DatePicker, Select } from 'antd';

import { VFlex } from '@/components/base';
import Typo from '@/components/Typography/Typo';
import { CHART_FREQUENCY, CHART_TERM_TYPE } from '@/entities/chart/model/constants';
import useChartStateAction from '@/features/(charts)/chart-controller/hooks/use-chart-state-action/useChartStateAction';
import chartUtils from '@/features/(charts)/chart-renderer/lib/chart-utils';
import { ChartFrequencyMap } from '@/features/(charts)/chart-renderer/model/chart-maps';
import {
  getDateRangeWithEndDateOffset,
  getPickerType,
  getTimezoneDayjs,
} from '@/utils/time';

type Props = {
  chartInfo: ChartContextProps;
};

const ChartTermCustomPicker = (props: Props) => {
  const { chartInfo } = props;
  const { state } = chartInfo;
  const term = state.target.term;
  if (term.type === CHART_TERM_TYPE.PERIODIC)
    throw new Error('Periodic term is not supported');

  const currentValues = getDateRangeWithEndDateOffset([
    getTimezoneDayjs(term.start_date),
    getTimezoneDayjs(term.end_date),
  ]);

  const { onCustomTermChange, onFrequencyChange } =
    useChartStateAction(chartInfo);

  const readableDateRange = chartUtils.getReadableDateRangeByTerm(
    state.target.term,
  );

  return (
    <VFlex g={16}>
      <DatePicker.RangePicker
        allowEmpty
        size="middle"
        picker={getPickerType(
          state.historical.frequency || CHART_FREQUENCY.DAY,
        )}
        value={currentValues}
        onChange={onCustomTermChange}
      />
      {state.historical.value && (
        <VFlex g={12}>
          <Typo type="label2">Frequency</Typo>
          <Select
            style={{ width: 120 }}
            value={state.historical.frequency}
            options={ChartFrequencyMap.toArray()}
            onChange={onFrequencyChange}
          />
        </VFlex>
      )}
      <Typo type="label3" className="text-gray-600">
        {readableDateRange}
      </Typo>
    </VFlex>
  );
};

export default ChartTermCustomPicker;
